import { createStore } from 'vuex'
import {useRoute} from "vue-router";

export default createStore({
    state: {
        taxRates: null,
        defaultTaxRate: null,
        sectors: [],
        locations: [],
        userAdditionals: {
            credits: [],
            licences: [],
        },
    },
    actions: {
        populateTaxRates({ commit }) {
            if (window.Laravel) {
                commit('SET_TAX_RATES', window.Laravel.taxRates)
            }
        },

        populateDefaultTaxRate({ commit }) {
            if (window.Laravel) {
                commit('SET_DEFAULT_TAX_RATE', window.Laravel.defaultTaxRate)
            }
        },

        populateSectors({ commit }) {
            if (typeof route == 'function') {
                return new Promise((resolve, reject) => {
                    axios.get(route('sectors'))
                        .then((response) => {
                            commit('SET_SECTORS', response.data.results)
                            resolve()
                        })
                })
            }
        },

        populateLocations({ commit }) {
            if (typeof route == 'function') {
                return new Promise((resolve, reject) => {
                    axios.get(route('locations'))
                        .then((response) => {
                            commit('SET_LOCATIONS', response.data.results)
                            resolve()
                        })
                })
            }
        },

        populateUserAdditionals({ commit }) {
            if (typeof route == 'function') {
                const vueRoute = useRoute()
                return new Promise((resolve, reject) => {
                    axios.get(route('transactions.additionals', { user: vueRoute.params.userId }))
                        .then((response) => {
                            commit('SET_USER_ADDITIONALS', response.data)
                            resolve()
                        })
                })
            }
        }
    },
    mutations: {
        SET_TAX_RATES(state, rates) {
            state.taxRates = rates
        },
        SET_DEFAULT_TAX_RATE(state, rate) {
            state.defaultTaxRate = rate
        },
        SET_SECTORS(state, sectors) {
            state.sectors = sectors
        },
        SET_LOCATIONS(state, locations) {
            state.locations = locations
        },
        SET_USER_ADDITIONALS(state, additionals) {
            state.userAdditionals = additionals
        }

    },
})
